module.exports = __webpack_public_path__ + "media/images/flags/cr-6f2d7bb05d9edb1089ec5bac86cf57c3.svg";